export const CountryCode = ({ code }: { code: string }) => (
  <span className="rounded border border-neutral-200 px-1 text-xs font-medium text-neutral-500">
    {code}
  </span>
);
